<template>
  <div class="logo" dir="ltr" :class="{'logo-audience': $store.state.logo}">
    <div class="logo-wrapper" v-if="canShowCustomLogo()">
      <img :src="$store.state.logo.large" alt>
    </div>
    <div
      class="logo-wrapper"
      :class="logoWrapperClass"
      v-if="canShowAhaSlideLogo()"
    >
      <aha-logo
        :icon-only="false"
        :useDefaultColor="true"
        class="default-logo ahaslides-logo"
      />
      <aha-logo
        :icon-only="false"
        :useDefaultColor="false"
        class="white-logo ahaslides-logo"
      />
    </div>
  </div>
</template>
<script>
import Util from '@/util'
import { mapGetters } from 'vuex'

export default {
  // `forceLightBackground` is for screens whose background is pinned light
  // independent of the deck's own theme (see App.vue's forced-light overrides).
  // Typed Boolean so the valueless `<Logo forceLightBackground />` casts to
  // true instead of the empty string an untyped prop would receive.
  props: {
    homepage: null,
    forceLightBackground: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('themeModule', ['isTextColourLight']),
    ...mapGetters('featureToggles', ['canUseHamburgerMenu']),
    logoWrapperClass() {
      if (!this.canUseHamburgerMenu) {
        return { 'dark-theme': this.$store.state.isDarkTheme }
      }
      const isPrivateMode = this.$store.state.presentation.privateMode
      return { 'logo-wrapper--on-dark': !this.forceLightBackground && !isPrivateMode && this.isTextColourLight }
    },
  },
  methods: {
    canShowAhaSlideLogo() {
      // If using whitelabel account, dont show AhaSlides logo
      if (Util.checkWhiteLabelDomain() || this.$store.state.presentation.planType === 'white-label') return false

      return this.homepage || (!this.$store.state.logo && !this.$store.state.presentation.notShowAhaSlidesLogo && !this.homepage)
    },
    canShowCustomLogo() {
      if (this.$store.state.presentation.notShowAhaSlidesLogo) {
        return false
      }
      return !this.canShowAhaSlideLogo() && this.$store.state.logo !== null
    },
  },
}
</script>

<style lang="scss" >
.dark-theme {
  .ahaslides-logo {
    color: white !important;
  }
}

.logo {
  padding: 20px 10px;
  margin: 0 auto;
  img, .ahaslides-logo {
    max-width: 140px;
    max-height: 48px;
    width: auto;
    height: auto;
    display: block;
    margin: 0 auto;

    &.white-logo {
      display: none;
    }
  }

  .logo-wrapper--on-dark {
    .default-logo {
      display: none;
    }

    .white-logo {
      display: block;
      color: white;
    }
  }
}

</style>
